import { useEffect, useState } from 'react';
import {
  onSessionExpired,
  offSessionExpired,
} from '@lib/utils/sessionExpiredEvent';

export default function useSessionExpired(): boolean {
  const [isSessionExpired, setIsSessionExpired] = useState(false);

  useEffect(() => {
    const handler = () => setIsSessionExpired(true);
    onSessionExpired(handler);
    return () => offSessionExpired(handler);
  }, []);

  return isSessionExpired;
}
